<template>
  <Modal
    v-if="doShow"
    class="LaptopExportModal"
    @close="$emit('update:doShow', false)">
    <Btn :isLoading="isExporting" @click="exportAll">
      {{ $t('exportAll') }}
    </Btn>
    <Btn :isLoading="isExporting" @click="exportAdditional">
      {{ $t('exportAdditional') }}
    </Btn>
  </Modal>
</template>

<script>
import { actions, getters } from '@utils'

export default {
  props: {
    doShow: Boolean,
    isExporting: Boolean,
  },
  computed: getters('articleFactory'),
  methods: {
    async exportAdditional() {
      const [result] = await this.$wrap(
        this.FIND_LAPTOP_IMPORT_EXPORT({
          customQuery: {
            isArchived: false,
          },
        }),
        'isExporting',
      )

      window.open(result.url)
    },
    async exportAll() {
      const { spreadsheetUrl } = await this.$wrap(
        async () => this.CREATE_ARTICLE_SHEET({
          articleId: null,
          topic: null,
          laptopEvaluations: null,
        }),
        'isExporting',
      )

      window.open(spreadsheetUrl)
    },
    ...actions(
      'CREATE_ARTICLE_SHEET',
      'FIND_LAPTOP_EVALUATION',
      'FIND_LAPTOP_IMPORT_EXPORT',
    ),
  },
}
</script>

<style lang="scss">
.LaptopExportModal {
}
</style>

<i18n>
{
  "en": {
    "exportAll": "Export all fields",
    "exportAdditional": "Export additional fields"
  }
}
</i18n>
